<template>
    <div class="feedback-step question--no-tags">
        <div class="heading-third--pink ">{{ feedbackData.text }}</div>
        <div class="ordered-tags">
            <div v-for="(tag, index) in feedbackData.options.tags"
                :key="index"
                class="ordered-bubble">
                <span class="ordered-bubble--text">{{ tag }}</span>
                <NumberInput
                    v-on:update="updateTags"
                    :value="savedAnswer && savedAnswer.tags && savedAnswer.tags[index] ? savedAnswer.tags[index][1] : null"
                    :tag="tag"
                    :max="feedbackData.options.tags.length"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import NumberInput from '@/components/NumberInput.vue'

    export default {
        name: "StepOrderedTags",
        props: {
            feedbackData: {
                required: true,
                type: Object,
            },
            savedAnswer: {
                required: true,
            },
            surveyPassingId: {}
        },
        components: {
            NumberInput,
        },
        data() {
            return {
                yesNo: '',
                selectedTags: [],
                value: 1,
            }
        },
        mounted() {
            this.updateSelectedTags();
        },
        methods: {
            updateSelectedTags() {
                if (this.savedAnswer !== null) {
                    this.yesNo = this.savedAnswer.value;
                    this.selectedTags = this.savedAnswer.tags;
                    //console.log("There is a saved answer")
                }
                else {
                    // Iterate this.feedbackData.options['tags'] and create an array of objects with the following structure:
                    // {'tag', value}
                    // Then assign this array to this.selectedTags
                    //console.log("There is not a saved answer")
                    let tags = this.feedbackData.options['tags'];
                    let selectedTags = [];
                    for (let i = 0; i < tags.length; i++) {
                        //selectedTags.push({tag: tags[i], value: 1})
                        selectedTags.push([tags[i], 1])
                    }
                    this.selectedTags = selectedTags;
                }
            },
            updateTags(tag, value) {
                let index = this.selectedTags.findIndex(x => x[0] === tag);
                if (index > -1) {
                    let updatedTag = [...this.selectedTags[index]];
                    updatedTag[1] = value;

                    this.$set(this.selectedTags, index, updatedTag);
                }
                this.$emit('updateProgress', true);
            },
            selectYesNo(i) {
                if (i === this.yesNo) {
                    this.yesNo = ''
                }
                else {
                    this.yesNo = i;
                    this.selectedTags = []
                }
            },
            selectTag(tag) {
                if (this.yesNo !== 1)
                    this.yesNo = 1
                if (!this.selectedTags.includes(tag)) {
                    this.selectedTags.push(tag);
                } else {
                    let index = this.selectedTags.indexOf(tag);
                    if (index > -1) {
                        this.selectedTags.splice(index, 1);
                    }
                }
            }
        },
        computed: {
            stepResult() {
                let stepResult = {
                    answer_data: JSON.stringify({
                        value: this.yesNo,
                        tags: this.selectedTags,
                    }),
                    question_id: this.feedbackData.id,
                };
                if (this.surveyPassingId) {
                    this._lodash.assign(stepResult, {survey_passing_id: this.surveyPassingId});
                }
                return stepResult
            },
            canContinue() {
                return (this.yesNo === '' && this.selectedTags.length < 1) ? 0 : 1 ;
            },
            feedbackDataId() {
                return this.feedbackData && this.feedbackData.id;
            },
        },
        watch: {
            savedAnswer() {
                if (this.savedAnswer) {
                    this.yesNo = this.savedAnswer.value;
                }
                else {
                    this.yesNo = ''
                }
            },
            feedbackDataId() {
                if (!this.savedAnswer) {
                    this.yesNo = '';
                }
                this.updateSelectedTags();
            }
        },
    }
</script>

<style scoped>

</style>
